import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type PetsInputFields = {
  pets: string;
};

const PetsInput = ({
  petsFieldConfig,
}: {
  petsFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<PetsInputFields>();

  return (
    <TextArea
      label={t`Husdjur`}
      showOptionalLabel={
        petsFieldConfig === informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.pets?.message}
      {...register("pets", {
        required: {
          value:
            petsFieldConfig === informationFieldConfigValueSchema.enum.required,
          message: t`Ange information om husdjur`,
        },
      })}
    />
  );
};

export default PetsInput;
